import React, {useContext, useEffect, useState} from 'react';
import {setProfileImageRequest} from 'util/api';
import {UserContext} from 'components/user/UserContext';
import {PicturesContext} from 'util/image/PictureContext';
import UniversalProfileImage from 'components/universal/UniversalProfileImage';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';
import {Link} from "react-router-dom";

const ProfileEdit = () => {
    const {user} = useContext(UserContext);
    const {allPictures} = useContext(PicturesContext); // Get allPictures from context
    const [userPictures, setUserPictures] = useState([]);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const trueAllPictures = allPictures.filter(pic => pic.authorId === user.userId);
                setUserPictures(trueAllPictures);
                // Fetch and set images from context data
            } catch (error) {
                console.error('Error fetching images:', error);
            }
        };

        fetchImages();
    }, [allPictures]);

    const handleSetProfile = (imageId) => {
        setProfileImageRequest(imageId)
            .then(data => {
                user.setProfileImage(data.profilePictureId);
            })
            .catch(error => {
                console.error('Error setting profile image:', error);
            });
    };

    const handleImageClick = (picId) => {
        handleSetProfile(picId);
    };

    return (
        <div>
            <UniversalEmptyPageHeader text={'Set Profile Picture'} image={'set-profile'} desktopText={true}/>
            <div className="main-content-body-padding">
                {userPictures.length > 0 ? (
                    <div className="image-grid">
                        {userPictures.map((pic) => (
                            <div key={pic.id} className="user-icon" onClick={() => handleImageClick(pic.id)}>
                                <UniversalProfileImage id={pic.id} size={'64px'}/>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>You have no pictures to set as profile. <Link to="/upload">Upload some.</Link></p>
                )}
            </div>
        </div>
    );
};

export default ProfileEdit;
